import React from "react";
import * as R from "ramda"

interface LinealGaugeProps {
  actualSpeed_bps: number,
  bookedSpeed_bps: number | null | undefined
}

export const LinealGauge: React.FC<LinealGaugeProps> = ({
  actualSpeed_bps,
  bookedSpeed_bps,
}) => {
  const numberOfTicks = 34
  const breakIndex = (typeof bookedSpeed_bps === "number" &&  bookedSpeed_bps > 0) ?
                    Math.ceil(numberOfTicks * actualSpeed_bps / bookedSpeed_bps) : 
                    0;
  const arrowPosX = (typeof bookedSpeed_bps === "number" &&  bookedSpeed_bps > 0) ? 
                    32 * (numberOfTicks-1) * R.clamp(0, 1, actualSpeed_bps / bookedSpeed_bps) : 
                    null;

  return (
    <svg className="gauge-lineal" viewBox="0 0 1064 86" xmlSpace="preserve">
      {R.range(0,numberOfTicks).map(i => <rect x={i * 32} key={i} style={{ fill: i < breakIndex ? "#333333" : "#cccccc" }}/>)}
      {arrowPosX != null && <rect x={arrowPosX} className="current"/>}
    </svg>
  );
};
